<template>
  <div class="auto-container">
    <BotSettingsForm form-type="create" :data="initialState" />
  </div>
</template>
<script>
import BotSettingsForm from "./BotSettings/BotSettingsForm.vue";

export default {
  data() {
    return {
      initialState: {
        name: "",
        welcomeMessage: "Hello! How can I help you?",
        placeholder: "",
        primaryColor: "#4764d5",
        textColor: "#4F4F4F",
        fontSize: 16,
        chatHight: 550,
        localization: "en",
        hideLearnMore: false,
        hideToolTip: false,
        hideFeedbackButton: false,
        rtlMode: false,
        iconFromBottomDistance: 50,
        iconHorizontalDistance: 50,
        iconSize: 48,
        iconPosition: "BR",
        botIcon: "",
        userIcon: "",
        agentIcon: "",
      },
    };
  },
  components: {
    BotSettingsForm,
  },
};
</script>

<style scpoed>
.auto-container {
  padding: 48px 28px 70px 28px;
  overflow: auto;
  height: calc(100vh - 146px);
}
</style>
